import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=50e0c36d&scoped=true&"
import script from "./DetailDeposit.vue?vue&type=script&lang=ts&"
export * from "./DetailDeposit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0c36d",
  null
  
)

export default component.exports